module.exports = __webpack_public_path__ + "static/media/11.700e6530.png";